import React from "react";

import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import { Button } from "@/src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/src/components/ui/dropdown-menu";

import { COMPONENT_TYPES } from "../../../../constants/componentType";
import isPlatformTV from "../../../../utils/platform";
import {
  COMPONENT_TYPE_ICONS,
  COMPONENT_TYPE_LABEL_KEYS,
  CREATABLE_COMPONENT_TYPE_LIST,
  getComponentHref,
} from "../../tableParams/pageComponentColumns";

import type { JSX } from "react";

import type { PlatformRoutesParams } from "../../../../components/routes/PlatformRoutes";
import type { CreatableComponentType } from "../../tableParams/pageComponentColumns.types";

function CreateComponentButton(): JSX.Element {
  const { t } = useTranslation("editor-platform");
  const history = useHistory();
  const {
    projectSlug,
    pageId,
    platform = "web",
  } = useParams<PlatformRoutesParams>();

  const handleCreate = (type: CreatableComponentType): void => {
    history.push(getComponentHref(projectSlug, pageId, platform, type, "new"));
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button size="lg" type="button">
          <Plus />
          {t("createComponent")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {CREATABLE_COMPONENT_TYPE_LIST.map((type) => {
          const TypeIcon = COMPONENT_TYPE_ICONS[type];
          return (
            <DropdownMenuItem
              key={type}
              disabled={type === COMPONENT_TYPES.FAQ && isPlatformTV(platform)}
              onSelect={() => handleCreate(type)}
            >
              <TypeIcon />
              {t(COMPONENT_TYPE_LABEL_KEYS[type])}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateComponentButton;
